import { LayoutDashboard, Users, IdCard } from "lucide-react";
import type { NavItemType } from "../types";
import { TbLicense } from "react-icons/tb";

export const navigation: NavItemType[] = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: <LayoutDashboard size={18} />,
  },
  {
    name: "User Management",
    icon: <Users size={18} />,
    children: [
      { name: "Customers", href: "/customers", icon: <Users size={16} /> },
      { name: "Staff", href: "/staff", icon: <IdCard size={16} /> },
    ],
  },
  {
    name: "Billing",
    icon: <TbLicense size={18} />,
    children: [
      { name: "License", href: "/license", icon: <TbLicense size={16} /> },
    ],
  },
];

export const isDropdownItem = (
  item: NavItemType,
): item is import("../types").DropdownNavItem => {
  return "children" in item;
};
